import VueRouter from "vue-router"
import Layout from "@/layout"
import Login from "@/container/login"
import Staff from "@/container/staff"
import StaffList from "@/container/staff/list"
import StaffEdit from "@/container/staff/edit"
import StaffImport from "@/container/staff/import"
import Salary from "@/container/salary"
import Secret from "@/container/secret"
const [routerPush, routerReplace] = [
  VueRouter.prototype.push,
  VueRouter.prototype.replace,
];
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error);
};
const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/staff",
    menus: true,
    children: [
      {
        path: "/staff",
        component: Staff,
        menu: "员工列表",
        iconClass: "icon-staff",
        children: [
          {
            path: "/",
            name: "StaffList",
            component: StaffList,
          },
          {
            path: "edit",
            name: "StaffEdit",
            component: StaffEdit,
          },
          {
            path: "import",
            name: "StaffImport",
            component: StaffImport,
          },
        ]
      },
      {
        path: "/salary",
        name: "Salary",
        component: Salary,
        menu: "工资通知",
        iconClass: "icon-salary"
      },
      {
        path: "/secret",
        name: "secret",
        component: Secret,
        menu: "安全秘钥",
        iconClass: "icon-key"
      },
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  }
]
const router = new VueRouter({
  mode: "history",
  routes
})
export { router, VueRouter }